import { DatePivotParams } from "../../entities/date_pivot_params";
import dayjs from "../../utils/dayjs";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "order_date",
  segments: ["supplier", "location"],
  minDate: dayjs.utc().startOf("month").toDate(),
  maxDate: dayjs.utc().add(6, "month").startOf("month").toDate(),
  filters: [],
};
